<template lang="pug">
#messageH5
  .top
    van-nav-bar(title="消息")
      template(#right)
        i.el-icon-more(@click="showCheck")
  .top_tabs
    van-tabs( v-model="isRead" color="#5587F0" line-width="30" @click="initList")
      van-tab(title="未读" name="0")
      van-tab(title="已读" name="1")
    van-search.keyword(v-model="keyword" placeholder="输入标题,项目名称或编号" shape="round"  @search="initList")
  .container
    ul
      li(v-for="item in tabsArray" :class="{ active: category == item.id }"
      :title="item.name" @click="changeTabs(item.id)") {{item.name}}
    .innerD
      van-pull-refresh(v-model="refreshing", @refresh="onRefresh", success-text="刷新成功")
        van-list(v-model="loading", :finished="finished", finished-text="没有更多了", @load="onLoad")
          van-checkbox-group(v-model="checkMessage")
            .messageItem(v-for="(item, index) in messageData" :key="index" )
              .messageDesc(@click="onItemClick(item, index)" @touchstart="touchstart(index)" @touchend="touchend")
                van-checkbox.mesId(ref="checkboxes" :name="item.messageInfoVo.messageId" icon-size="15px" v-show="hasCheck")
                van-badge(:dot="!item.isRead" :class="{ left: hasCheck }")
                  van-image.userAvator(width="46" height="46" fit="contain" round :src="imgUrl(item.messageInfoVo.senderId)")
                .desc
                  .title {{item.messageInfoVo.senderName}} {{ item.messageInfoVo.title }}
                  .flowDesc {{ item.messageInfoVo.content }}
                  .flowDesc2
                    span  {{item.messageInfoVo.createDate}}
                    span.hasprj(v-if="item.messageInfoVo.prjName") 来自：{{ item.messageInfoVo.prjName }}
              //- 长按弹框
              .longPopover(v-show="longIndex===index")
                van-cell(@click="readItem(item.messageInfoVo.messageId)") 标为已读
                van-cell(@click="deleteItem(item.messageInfoVo.messageId)") 删除
              .overlay(v-show="longIndex===index" @click="longIndex=''")
    .bottom(v-show="hasCheck")
      el-button.read(type="primary" v-show="isRead==='0'" round @click="readCheck") 标为已读
      el-button.danger(type="danger" plain  round @click="delCheck") 删除

</template>

<script>
import messageRequest from "@/CommonDP/service/message-service";
import keyCatalog from "@/CommonDP/service/folder-service";
import * as uni from "@/CommonDP/mongeView/appView/component/uni.webview.1.5.2";
import { gettouxAvatar } from "@/CommonDP/utils";
import { Toast } from 'vant';

import { mapState } from "vuex";
export default {
  data () {
    return {
      isRead: "0",
      category: "",
      keyword: "",
      tabsArray: [
        { id: "", name: "全部" },
        { id: "2", name: "流程" },
        { id: "1", name: "批注" },
        { id: "0", name: "项目" },
        { id: "4", name: "计划" },
        { id: "3", name: "其他" }
      ],
      messageData: [],
      hasCheck: false,
      checkMessage: [],
      // 加载页
      page: {
        pageNum: 0,
        pageSize: 10,
        totalCount: 0
      },
      refreshing: false, // 下拉刷新
      loading: false, // 上拉加载
      finished: false, // 加载与不加载的状态
      newEnterpriseId: "",
      longTimeout: null, // 长按定时器
      longIndex: ""
    };
  },
  computed: {
    ...mapState({
      localEnterpriseId: (state) => state.enterprise.enterpriseId
    }),
    enterpriseId() {
      return this.newEnterpriseId || this.localEnterpriseId;
    },
    requestParams() {
      const { isRead, keyword, enterpriseId, category, page: { pageNum, pageSize }} = this;
      return { isRead, prjId: "", content: "", keyword, pageNum, pageSize, category, enterpriseId };
    }
  },
  watch: {
    $route: {
      // 亲测有效,我是用来监听query参数变化
      handler() {
        this.newEnterpriseId = this.$route.query.enterpriseId;
        if (this.newEnterpriseId) {
          this.isRead = "0";
          this.category = "";
          this.initList();
        }
      },
      deep: true
    }
  },
  methods: {
    // 加载事件
    async onLoad() {
      if (this.refreshing) {
        this.messageData = [];
        this.refreshing = false;
      }
      this.page.pageNum++;
      await this.getList();
    },
    // 获取消息接口
    async getList() {
      const { data, totalCount, pageIndex } = await messageRequest.messageList(this.requestParams);
      this.page.totalCount = totalCount;
      this.page.pageNum = pageIndex;
      this.messageData = [...this.messageData, ...data];
      this.loading = false;
      this.messageData.length >= totalCount ? this.finished = true : this.finished = false;
      this.longIndex = "";
    },
    // 下拉刷新
    async onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page.pageNum = 0;
      await this.onLoad();
      this.refreshing = false;
    },
    changeTabs(id) {
      this.category = id;
      this.initList();
    },
    initList() {
      this.messageData = [];
      this.page.pageNum = 0;
      this.onLoad();
      this.hasCheck = false;
    },
    showCheck() {
      this.hasCheck = !this.hasCheck;
      if (!this.hasCheck) {
        this.checkMessage = [];
      }
    },
    async deleteItem(id) {
      await messageRequest.messageDelete([id]);
      Toast("删除成功");
      this.initList();
    },
    async readItem(id) {
      await messageRequest.messageRead([id]);
      Toast("标记为已读");
      this.initList();
    },
    async readCheck() {
      if (this.checkMessage.length === 0) {
        Toast("您未选择消息");
        return;
      }
      await messageRequest.messageRead(this.checkMessage);
      Toast("标记为已读");
      this.initList();
    },
    async delCheck() {
      if (this.checkMessage.length === 0) {
        Toast("您未选择消息");
        return;
      }
      await messageRequest.messageDelete(this.checkMessage);
      Toast("删除成功");
      this.initList();
    },
    // 选中项(已读 || 跳转 )
    async onItemClick(item, index) {
      if(this.hasCheck){
        return this.$refs.checkboxes[index].toggle();
      }
      const { category, prjId, prjIsDelete } = item.messageInfoVo;
      if (category === 0 || category === 1) {
        if (prjIsDelete === "1") {
          Toast("该项目已经被删除");
          return;
        } else if (prjIsDelete === "0") {
          const res = await keyCatalog.checkCatalogIsInit({ prjId });
          if (!res.data) {
            this.$toast("您还未设置关键目录快去设置吧");
            return;
          }
        }
      }
      this.goBackApp(item.messageInfoVo);
    },
    // 回跳app端
    goBackApp(item) {
      const { category, prjId, prjName, prjCode, extraParams } = item;
      const data = {
        source: "", // 消息类型区分跳转不同页面
        prjObj: {
          prjId,
          prjName: prjCode + prjName,
          prjCode,
          originalPrjName: prjName
        }, // 项目信息
        questionId: JSON.parse(extraParams)?.questionId || "" // 批注问题id
      };
      let path = "";
      switch (category) {
        case 0:
          data.source = 'project';
          path = '/project-doc';
          break;
        case 1:
          data.source = 'comment';
          path = '/project-issue';
          break;
        case 2:
          data.source = 'process';
          path = '/project-approve';
          break;
        default:
          this.$toast("请去web端查看");
          break;
      }
      console.log("传值", { data });
      uni.postMessage({ data });
      if(this.$route.path === '/message' && path){
        this.$router.push(path);
      }
    },
    imgUrl(senderId) {
      return senderId ? gettouxAvatar(senderId) : "";
    },

    // 长按-开始
    touchstart(index){
      this.longTimeout = setTimeout(() => {
        console.log("长按事件")
        this.longIndex = index;
      }, 800);
    },
    // 长按-结束
    touchend(){
      clearTimeout(this.longTimeout);
      this.longTimeout = null;
    }
  }
};
</script>

<style lang="scss" scoped>
#messageH5{
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top_tabs{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ::v-deep .van-tabs{
      width: 100px;
      margin-left: 8px;
      .van-tabs__wrap{
        height: 34px;
      }
    }
    /deep/.van-tab span{
      font-size: 14px;
    }
    /deep/.van-tab--active span{
      font-weight: 700;
    }
    .keyword{
      flex-grow: 1;
    }
  }
  .container{
    flex: 1 1;
    padding-top: 10px;
    // padding: 10px 0;
    background-color: #F5F6FA;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ul{
      overflow-x: auto;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      height: 50px;
      padding-left: 10px;
      li{
        min-width: 60px;
        height: 25px;
        border-radius: 15px;
        margin-right: 5px;
        background-color: #F5F5F5;
        line-height: 25px;
        text-align: center;
      }
      .active{
        background: rgba(1, 102, 252, 0.1);
        color: #0166FC;
      }
    }
    ul::-webkit-scrollbar {
      height: 0 !important;
    }
    .innerD{
      flex: 1 1;
      overflow: auto;
    }
    .bottom{
      margin-top: 10px;
      background-color: #fff;
      // background-color: #F5F6FA;
      height: 60px;
      width: 100%;
      // width: calc(100% - 20px);
      border-radius: 5px;
      left: 5px;
      bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .el-button{
        width: 40%;
      }
      .danger{
        margin-left: 10px;
      }
    }
  }
}
.messageItem{
  border-bottom: 1px solid #F5F6FA;
  background-color: #fff;
  position: relative;
  &:hover{
    background-color: #EDEDED;
  }
  .messageDesc{
    width: 100%;
    min-height: 80px;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    .left{
      margin-left: 12px;
    }
    .desc{
      margin-left: 8px;
      width: 1px;
      flex-grow: 1;
      padding-right: 5px;
    }
    .title{
      line-height: 24px;
      font-size: 15px;
      font-weight: 600;
      color: #333;
      white-space: nowrap;
      overflow: auto;
    }
    .flowDesc{
      line-height: 22px;
      font-size: 14px;
      color: #666666;
      white-space: pre-wrap;
    }
    .flowDesc2{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      color: var(--info-color, #909399);
      font-size: 12px;
      line-height: 20px;
      .hasprj{
        color: var(--theme-color);
        max-width: calc(100% - 120px);
        white-space: nowrap;
        overflow: auto;
      }
    }
    .mesId{
      position: absolute;
      top: 6px;
      left: 6px;
    }
    .right{
      margin-left: auto;
    }
  }
  .longPopover{
    position: absolute;
    top: 35px;
    right: 10vw;
    width: 100px;
    box-shadow: 0px 4px 14.1px 0px #00000026;
    background-color: #fff;
    z-index: 10;
  }
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    z-index: 1;
  }
}
.oper{
  height: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  float: left;
  span{
    line-height: 30px;
    color: #fff;
  }
}
.oper.info{
  background-color: var(--theme-color);
}
.oper.danger{
  background-color: #F0675C;
}
::v-deep .van-badge--dot{
  width: 10px !important;
  height: 10px !important;
}
::v-deep .van-badge--fixed{
  top: 4px;
  right: 4px;
}
.van-pull-refresh{
  overflow: visible;
}
</style>
